import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-kpi-card',
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss',
})
export class KpiCardComponent {
  @Input() label: string = 'Label';
  @Input() value: number = 9999;
  @Input() change: number | null = 999;
  @Input() icon: string = 'trending-up-outline';
  @Input() unit: string = '';
  @Input() loading: boolean = false;

  @Input() formatFunction: (value: number) => string = (value) =>
    value as unknown as string;
}
